import { Link } from 'react-router';
import { selectCurrentUser } from '../../api/auth/authSlice';
import { useSelector } from 'react-redux';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';

export function NavMenu() {
    const user = useSelector(selectCurrentUser);

    return (
        <header className="max-h-screen">
            <div className={`hidden w-full h-full sm:flex sm:flex-col sm:items-center sm:h-full sm:overflow-hidden bg-gray-900 sm:w-[75px] duration-300 relative`}>
                <ul className="navbar-nav flex-grow">

                    <div className="my-3">
                        <img 
                            className="w-[50px] h-[50px]"
                            src="/logo_nav.png" 
                            alt="Logo Regiodental"/>
                    </div>

                    <div className="my-3 text-center">
                        <Link className="text-white text-center" to="/empresa">
                            <BusinessRoundedIcon sx={{ width: 30, height: 30 }} />
                        </Link>
                    </div>

                    <div className="my-3 text-center">
                    <Link className="text-white" to="/pipeline">
                        <PaidRoundedIcon sx={{ width: 30, height: 30 }} />
                    </Link>
                    </div>

                    <div className="my-3 text-center">
                        <Link className="text-white" to="/calendario">
                            <CalendarMonthRoundedIcon sx={{ width: 30, height: 30 }} />
                        </Link>
                    </div>

                    <div className="my-3 text-center">
                        <Link className="text-white" to="/calendario-empresas">
                            <CalendarTodayRoundedIcon sx={{ width: 30, height: 30 }} />
                        </Link>
                    </div>

                    <div className="border border-white rounded"></div>

                    <div className="my-3 text-center">
                        <Link className="text-white" to="/vendedores">
                            <GroupsRoundedIcon sx={{ width: 30, height: 30 }} />
                        </Link>
                    </div>

                </ul>

                {user?.role == "Administrador" && (
                <ul>
                    <div className="my-3 text-center">
                        <Link className="text-white" to="/panel">
                            <AdminPanelSettingsRoundedIcon sx={{ width: 30, height: 30 }} />
                        </Link>
                    </div>
                </ul>
                )}

            </div>
        </header>
    );

}
